export const UPDATE_INFO = 'UPDATE_INFO'